import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import autoBind from 'react-autobind';
import { reduxForm, Form, Field, Fields, getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import FormError from 'ui/common/form/form-error';
import SimpleSelectField from 'ui/common/form/fields/simple-select-field';
import ApiAutoCompleteField from 'ui/common/form/fields/api-auto-complete-field';

import { selectAllSkillCategoriesForSelection } from 'store/features/skill-categrories/selectors';
import validator from 'ui/common/form/validator';

import fields, { fieldNames } from './model';
import * as messages from './messages';
import { autoSuggestSkills } from 'api/config/skills';
import { skillLevelIdsOrder, skillLevels } from 'resources/skills/levels';
import { addUserSkill } from 'store/features/users/skills/actions';
import { selectCurrentUserId } from 'store/features/auth/selectors';
import { selectSkillIsHighlighted } from 'store/features/users/selectors';

const { request: addUserSkillRequest } = addUserSkill;

export const FORM_NAME = 'add-user-skill';
const validate = validator(fields);

class AddUserSkillForm extends Component {
  constructor(props) {
    super(props);

    autoBind(this);
  }

  onSubmit(values) {
    const { currentUserId, modalName, isHighlighted } = this.props;

    this.props.addUserSkillRequest(
      { userId: currentUserId, values, isHighlighted },
      { form: FORM_NAME, modal: modalName }
    );
  }

  render() {
    const {
      selectedCategoryId,
      categoryOptions,
      levelOptions,
      className,
      handleSubmit,
      form: formName,
      intl: { formatMessage },
    } = this.props;

    return (
      <div className={className}>
        <Form onSubmit={handleSubmit(this.onSubmit)}>
          <FormError formName={formName} />

          <div className="row align-items-end">
            <div className="col-12 col-md-4">
              <Field
                name={fieldNames.category}
                component={SimpleSelectField}
                label={formatMessage(messages.labels[fieldNames.category])}
                options={categoryOptions}
              />
            </div>
            <div className="col-12 col-md-4">
              <Fields
                names={[fieldNames.skillName, fieldNames.skillId, fieldNames.skillSearch]}
                textFieldName={fieldNames.skillName}
                valueFieldName={fieldNames.skillId}
                searchFieldName={fieldNames.skillSearch}
                component={ApiAutoCompleteField}
                label={formatMessage(messages.labels[fieldNames.skillId])}
                apiRequestConfig={skillSearch =>
                  selectedCategoryId
                    ? autoSuggestSkills(skillSearch, selectedCategoryId)
                    : autoSuggestSkills(skillSearch)}
                apiResponseConfig={{ resultsKey: 'skills', textKey: 'name', valueKey: 'id' }}
              />
            </div>
            <div className="col-12 col-md-4">
              <Field
                name={fieldNames.level}
                component={SimpleSelectField}
                label={formatMessage(messages.labels[fieldNames.level])}
                options={levelOptions}
              />
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

const formValuesSelector = getFormValues(FORM_NAME);

function mapStateToProps(state, ownProps) {
  const allowedCategories = selectAllSkillCategoriesForSelection(state);

  const categoryOptions = allowedCategories.map(skillCategory => ({
    text: skillCategory.name,
    value: skillCategory.id,
  }));

  const allowedLevels = skillLevelIdsOrder.map(skillLevelId => skillLevels[skillLevelId]);

  const levelOptions = allowedLevels.map(skillLevel => ({
    text: skillLevel.name,
    value: skillLevel.id,
  }));

  const currentUserId = selectCurrentUserId(state);

  const selectedCategoryId = (formValuesSelector(state) || {})[fieldNames.category];

  const isHighlighted = selectSkillIsHighlighted(state);

  return {
    categoryOptions,
    levelOptions,
    currentUserId,
    selectedCategoryId,
    isHighlighted,
  };
}

const mapDispatchToProps = {
  addUserSkillRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({ form: FORM_NAME, validate })(injectIntl(AddUserSkillForm))
);
